Router = App.loadClass 'core::Router'

class exports.PortalCustomersRouter extends Router

    prefix: 'PortalCustomers'
    module_name: 'PortalCustomersRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'core::Angular/ReportFilters/FilterService', ['$http']
        @service 'portal::Angular/Customers/CustomersService', ['$http']

        @controller 'portal::Angular/Customers/SidebarController', [
            '$scope'
            '$transitions'
            '$state'
            'PortalCustomers.Services.FilterService'
            '$timeout'
        ]

        @controller 'portal::Angular/Customers/CustomersController', [
            '$scope'
            '$transitions'
            '$state'
            'PortalCustomers.Services.CustomersService'
            'PortalCustomers.Services.FilterService'
            'Core.Services.Loading'
            '$ngModal'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.customers',
                url: '/customers'
                templateUrl: 'backend/portal/customers/sidebar-layout'
                controller: 'PortalCustomers.Controllers.SidebarController'

            .state 'portal.customers.fullpage',
                url: '/report'
                views:
                    fullpage:
                        templateUrl: 'backend/portal/customers/main-layout'
                        controller: 'PortalCustomers.Controllers.CustomersController'
                        controllerAs: 'cus'